/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Home_Login_Pitch1Inputs */

const vi_sitesettings_home_login_pitch1 = /** @type {(inputs: Sitesettings_Home_Login_Pitch1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lời mời đăng nhập`)
};

/**

* @param {Sitesettings_Home_Login_Pitch1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_home_login_pitch1 = /** @type {((inputs?: Sitesettings_Home_Login_Pitch1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Home_Login_Pitch1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_home_login_pitch1(inputs)
});
export { sitesettings_home_login_pitch1 as "siteSettings_home_login_pitch" }